<script>
    import JourneyConnectionPropertyBase from "./JourneyConnectionPropertyBase.vue";
    import ErrorMessage from "../../../../../Components/Errors/ErrorMessage.vue";
    
    export default {
        name: 'journey-connection-error-message',
        render(createElement, context) {
            return createElement(JourneyConnectionPropertyBase, [ 
                createElement(ErrorMessage, { props: this.$props }) 
            ]);
        },
        props: {
            message: {
                type: String,
                required: true
            },
            fieldName: {
                type: String,
                required: false
            }
        }
    }
</script>